<template>
    <div class="" style="max-width: 100%;">
        <s-select :clearable="clearable" :autocomplete="autocomplete" :label="label" :items="itemsCarriers"
            :disabled="disabled" :item-text="itemText" :item-value="itemValue" :return-object="returnObject"
            @input="input" @change="change" placeholder="Seleccionar transportista" :slotTmp="true" :value="value" :text="text"
            id="scarrier" ref="scarrier">
            <template #item="{ item }">
                <div style="display:flex; flex-direction:column;width: 100%;max-width: 240px;">
                    <div class="font-weight-medium">{{ item.SpcDocument }}</div>
                    <p class="text--secondary text-caption ma-0" style="text-transform: uppercase;display: block;">
                        {{ item.SpcCompanyName }}
                    </p>
                </div>
            </template>
            <template v-slot:append-outer>
                <v-icon v-if="add" style="cursor: pointer; margin-top: 3px" @click="addEvent()"
                    color="success darken-1">
                    mdi-plus-circle-outline
                </v-icon>
                <slot v-else name="append-outer"> </slot>
            </template>
        </s-select>

        <v-dialog light style="border-radius: 0px !important" v-model="dialogAdd" v-if="dialogAdd" persistent
            max-width="900" transition="dialog-bottom-transition">
            <v-col class="pb-2">
                <spc-carriers @refresh="refresh($event)" :close="true" @close="dialogAdd = false"></spc-carriers>
            </v-col>
        </v-dialog>
    </div>
</template>
<script>
import _sVehicle from "@/services/Management/VehicleService";
import _SpcCarrierService from "@/services/SupplyChain/Transport/SpcCarrierService.js";
import SpcCarriers from "../../views/SupplyChain/Transport/SpcCarriers.vue";

export default {
    name: "SelectCarrier",
    components: { SpcCarriers },
    props: {
        autofocus: {
            type: Boolean,
            default: false,
        },
        add: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        value: {
            required: false,
            default: 0,
        },
        text: {
            type: String,
            default: ""
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        autocomplete: {
            type: Boolean,
            default: true,
        },
        label: {
            type: String,
            default: "Transportista",
        },
        itemValue: {
            type: String,
            default: "SpcDocument",
        },
        itemText: {
            type: String,
            default: "SpcFullCompanyName"
        },
        filterType: {
            type: Number | null,
            default: null
        }
    },
    data() {
        return {
            dialogAdd: false,
            itemsCarriers: [],
        };
    },
    created() {
        this.loadcarriers();
    },
    watch: {},
    computed: {},
    methods: {
        input(val) {
            this.$emit("input", val);
        },
        change: function (value) {
            this.$emit("change", value);
            this.$emit("input", value);
        },
        refresh(item) {
            console.log(item);
            this.loadcarriers();
        },
        addEvent() {
            this.dialogAdd = true;
        },
        loadcarriers() {
            _SpcCarrierService.list({ Search: '', Type: this.filterType }, this.$fun.getUserID()).then(result => {
                if (result.status == 200) {
                    this.itemsCarriers = result.data.map(x => ({
                        ...x, SpcFullCompanyName: `${x.SpcDocument} - ${x.SpcCompanyName}`
                    }))
                }
            })
        }
    },
};
</script>
